import { Loader } from '@strivelabs/ui-core/v2';
import { cn } from '@strivelabs/ui-core/lib/utils';

export interface ChatStatusDotProps {
  /** The conversation is streaming a reply, in either this tab or its own tab. */
  busy?: boolean;
  className?: string;
}

/**
 * A 6px outline dot at rest, a spinner while a reply streams. Both are drawn in
 * `currentColor`, so the mark takes the ink of whatever slot holds it; the
 * resting dot is held well back, since a row that is doing nothing should not
 * be the thing the eye lands on.
 */
export function ChatStatusDot({ busy, className }: ChatStatusDotProps) {
  if (busy) {
    return (
      <Loader
        variant="spinner"
        size={11}
        speed={0.7}
        label="Streaming"
        /* `Loader` pins its own ink; `text-current` hands it back to the slot. */
        className={cn('text-current', className)}
      />
    );
  }

  return (
    <span
      aria-hidden
      className={cn(
        'inline-block size-1.5 shrink-0 rounded-full opacity-45',
        'bg-transparent ring-1 ring-inset ring-current',
        className,
      )}
    />
  );
}
